module.exports = __webpack_public_path__ + "img/img-7a3741.jpg";